module.exports = __webpack_public_path__ + "static/img/newanli-21.64157a59.jpg";